export default __webpack_public_path__ + "static/media/Inter-UI-ExtraLightItalic-BETA.8ff9d796.woff2";